// extracted by mini-css-extract-plugin
export default {"container":"FileUploadContainer_container__8A-Uq"};